/* eslint-disable jsx-a11y/heading-has-content, react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  ReactAux,
  Section
} from '@jkhy/vsg-design-system';
import CurrentRequestApplication from './application';
import { AppState as AppState_ } from '../../redux/app-state';
import CurrentApplication_ from '../../data/models/CurrentRequestApplication';
import { ListItemNames } from '../../utils/enum';
import ListAPI from '../../data/list-api';
import ListItem_ from '../../data/models/ListItem';
import { setCurrentApplications } from '../../redux/actions/current-applications-actions';
import { endLoading, startLoading } from '../../redux/actions/loading-actions';
import CurrentApplicationsAPI from '../../data/current-applications-api';
import { getRequiredDocuments } from '../../redux/actions/doc-actions';
import RequiredDocument_ from '../../data/models/RequiredDocumet';
import { CountingModel as CountingModel_ } from '../../redux/actions/counts-qd-enabled-actions';
import BaseAPI from '../../data/base-api';
import { healthCheck as healthCheckAction, HealthCheckModel as HealthCheckModel_ } from '../../redux/actions/health-check-actions';
import { joinValidElementsInString } from '../../utils/helper';
import PublicContent from '../../data/models/PublicContent';
import { AppDispatch } from '../../data/models/AppDispatch';
import '../../../css/default.css';

export const PageDataUI = 'CurrentRequests';

const CurrentRequests = () => {
  const [listItems, setListItems] = useState<ListItem_[]>([]);
  const {
    currentApplications,
    requiredDocuments,
    requiredDocumentsFetched,
    healthCheck,
  } = useSelector<AppState_, {
    currentApplications: CurrentApplication_[],
    requiredDocuments: RequiredDocument_[],
    requiredDocumentsFetched: CountingModel_,
    healthCheck: HealthCheckModel_,
  }>((state: AppState_) => ({
    currentApplications: state.currentApplications,
    requiredDocuments: state.doc,
    requiredDocumentsFetched: state.reqDocsFetched,
    healthCheck: state.healthCheck,
  }));

  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    const initData = async () => {
      try {
        dispatch(startLoading());

        const { payload: { isChecked, status, }, } = await dispatch(healthCheckAction());

        if (isChecked && status === 200) {
          const pars = {
            listName: ListItemNames.PortalApplicationStatus,
          };

          const { result: allListItems, errorCode, } = await ListAPI.getLtItemsSearch(pars);
          if (errorCode <= 0) {
            const activeListItems = allListItems
              // secondCode is used by StatusBar/ApplicationStepsProgress logic, should be number
              .filter((listItem: ListItem_) => !listItem.isHidden && !Number.isNaN(parseInt(listItem.secondCode, 10)))
              .sort((a: ListItem_, b: ListItem_) => parseInt(a.secondCode, 10) - parseInt(b.secondCode, 10));
            setListItems(activeListItems);
          }

          const { result: allApplications, errorCode: currentApplicationErrorCode, } = await CurrentApplicationsAPI.getCurrentApplications();

          if (currentApplicationErrorCode <= 0) {
            const sortedAllApplications = allApplications.sort((a, b) => new Date(b.dateStarted)?.getTime() - new Date(a.dateStarted)?.getTime());
            dispatch(setCurrentApplications(sortedAllApplications));
          }

          // If require documents are not fetched.
          if ((requiredDocumentsFetched?.count > 0 && requiredDocuments?.length === 0) || !requiredDocumentsFetched.isFetched) {
            dispatch(getRequiredDocuments());
          }
        }
      } catch (err) {
        BaseAPI.onError(err);
      } finally {
        dispatch(endLoading());
      }
    };

    initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { currentRequestPageTitle, currentRequestPageDescription, } = window?.PublicContent ?? new PublicContent();

  if (healthCheck.isChecked && healthCheck.status !== 200) {
    return (
      <Section
        title="Current Requests"
        dataUI={PageDataUI}
      >
        <p className="mb-3">{healthCheck.status}</p>
      </Section>
    );
  }

  return (
    <ReactAux>
      <Section dataUI={PageDataUI}>
        <h1 data-ui={`${PageDataUI}-page-title`} className="mb-2 text-preline break-word">{currentRequestPageTitle}</h1>
        <p data-ui={`${PageDataUI}-page-description`} className="mb-3 text-preline break-word">{currentRequestPageDescription}</p>

        {currentApplications?.length > 0 && currentApplications.map(application => {
          const {
            applicationNumber,
            guidqdApplication,
            guidqdParty,
            email,
            idFile,
          } = application;

          const key = joinValidElementsInString([applicationNumber, guidqdApplication, guidqdParty, idFile, email], '-');

          return (
            <CurrentRequestApplication
              key={key}
              application={application}
              listItems={listItems}
            />
          );
        })}
      </Section>
    </ReactAux>
  );
};

export default CurrentRequests;
